export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7649.7b765ec4.jpg";